export default "__VITE_ASSET__c243ff98__"